import { useState } from 'react';
import Error from './Error';
import shortid from 'shortid';
import PropTypes from 'prop-types';

const Formulario = ({ guardarGasto, guardarControlGasto }) => {
  //states de gastos
  const [nombregasto, guardarNombreGasto] = useState('');
  const [cantidadgasto, guardarCantidadGasto] = useState(0);

  //state de error
  const [error, guardarError] = useState(false);

  //funcion que agrega gasto
  const agregarGasto = (e) => {
    e.preventDefault();

    // validar campos se ingresen de forma correcta
    if (cantidadgasto < 1 || isNaN(cantidadgasto) || nombregasto.trim === '') {
      guardarError(true);
      return;
    }

    guardarError(false);

    //construir el gasto
    const gasto = {
      nombregasto,
      cantidadgasto,
      id: shortid.generate(),
    };

    // pasar el gasto al componente principal
    guardarGasto(gasto);
    guardarControlGasto(true);

    // resetear el form
    guardarNombreGasto('');
    guardarCantidadGasto(0);
  };

  return (
    <form onSubmit={agregarGasto}>
      <h2>Agrega tus gastos aqui</h2>

      {error ? (
        <Error mensaje='Ambos campos son obligatorios o presupuesto incorrecto' />
      ) : null}

      <div className='campo'>
        <label>Nombre gasto</label>
        <input
          type='text'
          className='u-full-width'
          placeholder='Ej. Transporte'
          value={nombregasto}
          onChange={(e) => guardarNombreGasto(e.target.value)}
        />
      </div>

      <div className='campo'>
        <label>Cantidad gasto</label>
        <input
          type='number'
          className='u-full-width'
          placeholder='Ej. 300'
          value={cantidadgasto}
          onChange={(e) => guardarCantidadGasto(parseInt(e.target.value, 10))}
        />
      </div>

      <input
        type='submit'
        className='u-full-width button-primary'
        value='AGREGAR GASTO'
      />
    </form>
  );
};

Formulario.propTypes = {
  guardarGasto: PropTypes.func.isRequired,
  guardarControlGasto: PropTypes.func.isRequired,
};

export default Formulario;
